<section>
  <div class="row">
      <div class="col-md-12">
          <!--Row 1 Start-->
        <div class="row">
          <div class="col"><span><strong>{{orderLblText.orderNumberLbl}}:</strong></span></div>
          <div class="col"><span>{{orderHeader?.orderNumber}}</span></div>
          <div class="col"><span><strong>Job Name:</strong></span> </div>
          <div class="col"> <span>{{orderHeader?.jobName}}</span></div>

          <div class="col"><span><strong>Shipping Address:</strong></span> </div>
          <div class="col-md-2">
            <span>
              {{orderHeader?.shipToCustomerNumber}}-{{orderHeader?.shipToCustomerName}}<br />
              {{orderHeader?.shipToAddressLine1}}<br />
              {{orderHeader?.shipToCity}},{{orderHeader?.shipToState}} {{orderHeader?.shipToZipCode}}
            </span>
          </div>
        </div>
          <!--Row 1 End-->
          <!--Row 2 Start-->
          <div class="row">
              <div class="col"><span><strong>Cust #:</strong></span></div>
              <div class="col"><span>{{orderHeader?.billToCustomerNumber}}</span></div>
              <div class="col"><span><strong>Received Date:</strong></span> </div>
              <div class="col"> <span>{{orderHeader?.orderDate | date: 'MM/dd/yyyy'}}</span></div>
              <div class="col"><span><strong>Request Date:</strong></span></div>
              <div class="col-md-2"><span>{{orderHeader?.requestDate | date: 'MM/dd/yyyy'}}</span></div>
          </div>
          <!--Row 2 End-->
          <!--Row 3 Start-->
          <div class="row">
              <div class="col"><span><strong>Cust Name:</strong></span></div>
              <div class="col"><span>{{orderHeader?.billToCustomerName}}</span></div>
              <div class="col"></div>
              <div class="col"></div>
              <div class="col"><span><strong>Contact:</strong></span></div>
              <div class="col-md-2"><span>{{orderHeader?.userEmailId}}</span></div>
          </div>
          <!--Row 3 End-->
          <!--Row 4 Start-->
          <div class="row">
              <div class="col"><strong>Market Segment Name:</strong></div>
              <div class="col">{{orderHeader?.marketSegmentName}}</div>
              <div class="col"></div>
              <div class="col"></div>
              <div class="col"><span><strong>PO#:</strong></span></div>
              <div class="col-md-2">{{orderHeader?.po}}</div>
          </div>
          <!--Row 4 End-->
          <!--Row 5 Start-->
          <div class="row">
              <div class="col"><span><strong>Comments:</strong></span></div>
              <div class="col"><span>{{orderHeader?.comments}}</span></div>
              <div class="col"></div>
              <div class="col"></div>
              <div class="col"></div>
              <div class="col-md-2"></div>
          </div>
          <!--Row 5 End-->
      </div>
  </div>
</section>
<br />
<section>
  <!--<p class="row">
    <span class="sample-request-order-summary"><strong>{{orderDetailsLblText.orderSummaryLbl}}</strong>:</span>
  </p>-->
  <kendo-grid [data]="orderDetailsGridData"
              class="orderSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="orderGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="orderGridstate.take"
              [skip]="orderGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="orderDetailsGridSortChange($event)"
              (pageChange)="orderDetailsGridPageChange($event)"
              (dataStateChange)="orderDetailsGridDataStateChange($event)"
              [filter]="orderGridSettings.state.filter"
              [loading]="orderLoading">
    <!--(columnReorder)="onReorder($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"-->
    <!--<ng-template kendoGridToolbarTemplate>
    <div class="k-grid-toolbar-button-display btn-web">
      <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
        {{orderDetailsLblText.exportToExcelLbl}}
        <kendo-loader *ngIf="loadingExcel"></kendo-loader>
      </button>
      <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
        {{orderDetailsLblText.exportToPDFLbl}}
        <kendo-loader *ngIf="loadingPDF"></kendo-loader>
      </button>
    </div>
  </ng-template>-->
    <kendo-grid-column *ngFor="let col of orderGridSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">

      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'salePrice'">
        {{dataItem.salePrice | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'extendedPrice'">
        {{dataItem.extendedPrice | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridFooterTemplate *ngIf="col.field == 'extendedPrice'">
        <h4>
          Total: {{orderTotal | currency}}
        </h4>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
  </kendo-grid>
</section>


<!--<hr />-->
<section>
  <div class="separator"><b>Sales Order Processing Details</b></div>
  <br />
  <div class="row">
    <div class="col-md-3"><span><strong># of Sales orders:</strong></span></div>
    <div class="col-md-3"><span><strong>Sales Order Numbers:</strong></span><br /><i>(Comma separated SO numbers)</i></div>
    <div class="col-md-3"><span><strong> Comments:</strong></span> </div>
    <div class="col-md-3" *ngIf="shouldBeReadOnly"><span><strong> Completed By:</strong></span> </div>
  </div>
  <div class="row" *ngIf="!shouldBeReadOnly">
    <div class="col-md-2">
      <input type="number"
             min="0"
             pattern="^[0-9]$"
             [(ngModel)]="numberOfSalesOrder" />
    </div>
    <div class="col-md-4"><textarea cols="40" row="10" [(ngModel)]="salesOrderNumbers"></textarea></div>
    <div class="col-md-6"><textarea cols="60" row="10" [(ngModel)]="processingComment"></textarea> </div>
  </div>
  <div class="row" *ngIf="shouldBeReadOnly">
    <div class="col-md-3"><span>{{numberOfSalesOrder}}</span></div>
    <div class="col-md-3"><span>{{salesOrderNumbers}}</span></div>
    <div class="col-md-3"><span>{{processingComment}}</span> </div>
    <div class="col-md-3"><span>{{orderCompletedBy}}</span> </div>
  </div>
</section>

<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  <button class="m-3 btn btn-success"
          style="margin: 0 auto;"
          kendoButton (click)="redirectToOrderHistoryPage()">
    Back
  </button>
  <button class="m-3 btn btn-success"
          style="margin: 0 auto;"
          *ngIf="!shouldBeReadOnly"
          kendoButton (click)="completeOrder()">
    Complete
    <kendo-loader *ngIf="updateInProcess" style="color:blue"></kendo-loader>
  </button>
</div>
